import {Directive, inject, Input, OnChanges} from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Need to import this here so we can wrap it.
import {BaseNamedRouterLinkDirective} from '@aviary/directives/base-named-router-link.directive';
import {RouteName} from '@app/app.route-names.generated';
import {Params} from '@angular/router';

@Directive({
  selector: 'a[pxNamedRouterLink]',
  hostDirectives: [BaseNamedRouterLinkDirective]
})
export class NamedRouterLinkDirective implements OnChanges {

  @Input({required: true}) public pxNamedRouterLink: RouteName;
  @Input() public pxNamedRouterLinkParams: Params = {};
  @Input() public pxQueryParams?: Params;

  private readonly aviaryDirective: BaseNamedRouterLinkDirective = inject(BaseNamedRouterLinkDirective);

  public ngOnChanges(): void {
    this.aviaryDirective.mxNamedRouterLink = this.pxNamedRouterLink;
    this.aviaryDirective.mxNamedRouterLinkParams = this.pxNamedRouterLinkParams;
    this.aviaryDirective.mxQueryParams = this.pxQueryParams;

    this.aviaryDirective.refreshLink();
  }
}
